import(/* webpackMode: "eager" */ "/var/www/pechatnov/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/pechatnov/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/pechatnov/src/app/homepage/components/ContactForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/pechatnov/src/app/notarialnaya-ocenka/components/CaseStudies.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/pechatnov/src/app/notarialnaya-ocenka/components/DocumentsChecklist.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/pechatnov/src/app/notarialnaya-ocenka/components/FAQSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/pechatnov/src/app/notarialnaya-ocenka/components/HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/pechatnov/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/pechatnov/src/components/ui/AppIcon.tsx");
